module.exports = __webpack_public_path__ + "media/images/countryrect/om-12c488e2470ee24c1106dee656036394.svg";